import { Component, OnInit, forwardRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PermissionModel } from '../definition/permission.model';
import { NzTreeNode } from 'ng-zorro-antd/tree';
import { TranslateService } from '@ngx-translate/core';
import { MmTranslateService } from '../../i18n';
import { map, filter, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { areArrayEqual } from '../../common';
import { IdentityStore } from '../identity-store';
import { MmIdentityService } from '../services';
import { NzTreeFlatDataSource, NzTreeFlattener } from 'ng-zorro-antd/tree-view';
import { FlatTreeControl } from '@angular/cdk/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { isThisSecond } from 'date-fns';

@Component({
  selector: 'mm-permission-select',
  templateUrl: './permission-select.component.html',
  styleUrls: ['./permission-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PermissionSelectComponent),
      multi: true
    }
  ]
})
export class PermissionSelectComponent implements OnInit, ControlValueAccessor {

  keys$ = new BehaviorSubject<string[]>([])
  writeValue(obj: any): void {
    this.keys$.next(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;

  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  onChange: (_: any) => void;

  onTouched: () => void;





  permissions$ = new BehaviorSubject<PermissionModel[]>([]);

  treeNodes$: Observable<NzTreeNode[]>;

  constructor(private translateService: MmTranslateService, private api: MmIdentityService) {

  }

  async ngOnInit() {
    this.permissions$.pipe(
      map(p => this.convertToNzTreeNodes(p)),
      tap(p => {
        this.dataSource.setData(p)
      })
    ).subscribe();

    // this.treeNodes$.pipe(
    //   distinctUntilChanged((a, b) => areArrayEqual(a, b)),
    //   tap(v => {
    //     debugger;
    //     if (this.onChange) {
    //       this.onChange(v);
    //     }

    //   })
    // ).subscribe();

    this.api.getPermissionTree().pipe(
      tap(permissions => { this.permissions$.next(permissions) }),
      switchMap(() => this.keys$),
      distinctUntilChanged((a, b) => areArrayEqual(a, b)),
      tap(keys => {
        if(keys != null)
          this.checklistSelection.select(...this.treeControl.dataNodes.filter(f => keys.findIndex(k => k == f.key) >= 0))
      })
    ).subscribe();
    // this.permissions$.pipe(
    //   tap(permissions => {

    //   })
    // ).subscribe()

    this.checklistSelection.changed.pipe(
      tap(x => {
        this.keys$.next(this.checklistSelection.selected.map(p => p.key));

      })
    ).subscribe();


    this.keys$.pipe(
      distinctUntilChanged((a, b) => areArrayEqual(a, b)),
      tap(keys => {
        if (this.onChange)
          this.onChange(keys);
      })

    ).subscribe();


  }

  modelChange(obj: any) {
    debugger;
  }
  checkChange(obj: any) {
    debugger;

  }

  private transformer = (node: TreeNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.name === node.name
        ? existingNode
        : {
          expandable: !!node.children && node.children.length > 0,
          name: node.name,
          level: level,
          key: node.key,
          disabled: !!node.disabled
        };
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };
  flatNodeMap = new Map<FlatNode, TreeNode>();
  nestedNodeMap = new Map<TreeNode, FlatNode>();
  checklistSelection = new SelectionModel<FlatNode>(true);

  treeControl = new FlatTreeControl<FlatNode>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new NzTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new NzTreeFlatDataSource(this.treeControl, this.treeFlattener);

  // constructor() {
  //   this.dataSource.setData(TREE_DATA);
  // }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  ngAfterViewInit(): void { }

  descendantsAllSelected(node: FlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return (
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      })
    );
  }

  descendantsPartiallySelected(node: FlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  indeterminateChecked(node: FlatNode): boolean {
    // const descendants = this.treeControl.getDescendants(node);
    // const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return !this.descendantsAllSelected(node) && this.checklistSelection.isSelected(node);
  }

  leafItemSelectionToggle(node: FlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  itemSelectionToggle(node: FlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  checkAllParentsSelection(node: FlatNode): void {
    let parent: FlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkRootNodeSelection(node: FlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }

  }

  getParentNode(node: FlatNode): FlatNode | null {
    const currentLevel = node.level;

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }


  convertToNzTreeNodes(models: PermissionModel[], parentNode?: TreeNode) {

    const nodes: TreeNode[] = [];

    for (const model of models) {
      const node = <TreeNode>{}
      let key = model.code;
      // if (parentNode) {
      //   key = `${parentNode.key}.${model.code}`
      //   // node.parentNode = parentNode;
      // }

      node.key = key;
      node.name = model.name[this.translateService.currentLang] || model.code;

      nodes.push(node);

      if (model.items && model.items.length > 0) {
        // node.isLeaf = false;
        node.children = this.convertToNzTreeNodes(model.items, node);
      }
      // else {
      //   node.isLeaf = true;
      // }
    }
    return nodes;
  }

}


interface TreeNode {
  name: string;
  key: string;
  disabled?: boolean;
  children?: TreeNode[];
}

interface FlatNode {
  expandable: boolean;
  name: string;
  key: string;
  level: number;
  disabled: boolean;
}